import { createContext } from 'use-context-selector';

export const KeyContext = createContext({
  myState: {},
  theme: {},
  helpers: {}
});
